export const NAV_LINKS = [
  { link: '/home', label: 'home' },
  { link: '/dapp', label: 'dApp' },
]

export const CONTRACT_ADDRESS = '0xc904C95D0cbf50342FD92C8ab4764819F5641808'
